<app-consignment-party-details
  [party]="party" [editMode]="editMode" [required]="true" [deletionAllowed]="true" [editAllowed]="false"
  [label]="consignmentUtils.organisationFormatter(organisation) || 'Select an organisation below'"
  [customAddTemplate]="customAddTemplate"
  [showTypeOfPerson]="false" [showCommunications]="false"></app-consignment-party-details>

<ng-template #customAddTemplate>
  @if (editMode) {
    <div class="row mb-3">
      <div class="col">
        <app-search [required]="true" [(ngModel)]="organisation" [searchFunction]="refData.findBulkAuthorisations"
                    [resultFormatter]="consignmentUtils.organisationFormatter"
                    [inputFormatter]="consignmentUtils.organisationFormatter"
                    (ngModelChange)="onOrganisationChange($event)" placement="Select an organisation"
                    [appAutoFocus]="!organisation?.iamConnectedId">
        </app-search>
      </div>
      <div class="col-auto">
        <button type="button" class="btn btn-plain btn-outline-danger border-0 p-1 h-100"
                (click)="organisationChange.emit(null)" style="box-shadow: none !important; width: 40px">
          <i class="fa fa-fw fa-light fa-trash-can"></i>
        </button>
      </div>
    </div>
  }
</ng-template>
